module.exports = __webpack_public_path__ + "img/Game_target_Z-30.b4cb5c82.png";